import React from 'react';
import ForgotPasswordComponent from '../common/login/ForgotPassword';

class ForgotPassword extends React.Component{
  render(){
    return <ForgotPasswordComponent />
  }
}

export default ForgotPassword;